<div class="widget" [ngClass]="{'loader-shown': loading, 'failed-to-load': failedToLoad}">
  <div class="widget-failed-to-load">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-form-stats">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element chart-loading"></div>
      <div class="legend-loading" *ngIf="widgetSize > 50">
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
        <div class="loader-element"></div>
      </div>
    </div>
  </div>
  <div class="widget-header">
    <span class="custom-icon">
      <span class="icon material-icons-outlined">pie_chart</span>
    </span>
    <span class="title">{{ settings.title }}</span>
  </div>
  <div class="widget-content">

    <div *ngIf="!noData" class="chart-wrapper">
      <div class="doughnut-chart">
        <p-chart #doughnutChart width="250px" height="250px" type="doughnut" [data]="doughnutData" [options]="doughnutOptions" [plugins]="doughnutPlugins"></p-chart>
        <div class="total">
          <span>{{ total }}</span>
          <small>Total</small>
        </div>
      </div>
      <div class="legend" *ngIf="widgetSize > 50">
        <ng-container *ngFor="let obj of data">
          <span class="color" [style.background]="obj.color"></span>
          <span 
            class="label"
            pTooltip="Click to copy"
            [tooltipDisabled]=" obj.label.length < 38"
            (click)="obj.label.length > 37 && clickToCopy( obj.label)">
            {{ obj.label }}
          </span>
        </ng-container>
      </div>
    </div>

    <div *ngIf="noData" class="custom-message">
      <span class="icon material-icons no-data">hourglass_empty</span>
      <p>No responses to display yet.</p>
      <small></small>
    </div>
    
  </div>
</div>